import { render } from "./Chapter2.vue?vue&type=template&id=0aa1b9d2"
import script from "./Chapter2.vue?vue&type=script&lang=js"
export * from "./Chapter2.vue?vue&type=script&lang=js"

import "./Chapter2.vue?vue&type=style&index=0&id=0aa1b9d2&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__